import React from 'react'
import MarketCard from './MarketCard'

const AllRankcard = () => {
  const obj = require("../../rankImage.json");
  return (
    <>
      {obj.map((value, i) => (
        <MarketCard key={i} value={value} variant="cover" category="rank" />
      ))}
    </>
  )
}

export default AllRankcard
